/**
 * BrandIcon — renders one of the Figma-exported brand icons from
 * `brandIcons.js` by name. SVGs are written with fill="currentColor" so
 * they pick up text color naturally; size is controlled here.
 *
 * Usage:
 *   <BrandIcon name="sessions" />               // 18×18 default
 *   <BrandIcon name="play" size={14} />
 *   <BrandIcon name="apple_logo" className="text-navy" />
 *
 * Renders nothing if the name isn't in the registry (returns null) so a
 * typo can't blow up the page.
 */
import React from 'react';
import CMS_ICONS from './brandIcons';
import { cn } from './cn';

export default function BrandIcon({ name, size = 18, className, style, title }) {
  const svg = CMS_ICONS[name];
  if (!svg) return null;
  return (
    <span
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      className={cn('inline-flex items-center justify-center shrink-0', className)}
      style={{
        width: size,
        height: size,
        lineHeight: 0,
        ...style,
      }}
      // The inner SVG is verbatim from the Figma export — sized via the
      // wrapper, colored via currentColor.
      dangerouslySetInnerHTML={{
        __html: svg.replace(
          '<svg ',
          `<svg width="${size}" height="${size}" style="display:block" `,
        ),
      }}
    />
  );
}
